import {KTIcon} from '../../../../_metronic/helpers'
const AddNewPromoModalHeader = ({
  setOpenPromoModal,
  selectedPromo,
  setSelectedPromo
}) => {  
  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>{selectedPromo && selectedPromo?.id ? `Update Promo Code of #${selectedPromo.code}` : "Add Promo Code" }</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() =>  {
        setOpenPromoModal(false)
        setSelectedPromo(null)
        }}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {AddNewPromoModalHeader}
